import { render, staticRenderFns } from "./OrderModalHistory.vue?vue&type=template&id=386c6f30&"
import script from "./OrderModalHistory.vue?vue&type=script&lang=js&"
export * from "./OrderModalHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderModalHistory.vue?vue&type=style&index=0&id=386c6f30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports